import { Stack } from '@festina-life/ui/structure'

import { GlMapTimelineDiagram } from '../../components/glMapTimeline/GlMapTimelineDiagram'

/**
 * Sidebar of the GL-map viewer, holding the version history used to pick the version
 * to view.
 */
export const GlMapSidebar = () => (
  <Stack
    gap="spacious"
    padding="spacious"
    className="size-full flex-col overflow-auto"
  >
    <GlMapTimelineDiagram />
  </Stack>
)
